import { Area, AreaContent } from "../../useAreas/areas/types";
import hero from "../../../../assets/image/areas/hero/gewerblicherRechtschutzUndUrheberrecht.webp";

const data: AreaContent = {
  id: Area.GEWERBLICHERRECHTSSCHUTZUNDURHEBERRECHT,
  hero: hero,
  content: [
    "Der gewerbliche Rechtsschutz und das Urheberrecht bilden das Fundament für den Schutz von Innovationen, kreativen Werken und unternehmerischer Identität.",
    "Während der gewerbliche Rechtsschutz insbesondere Marken, Designs und andere gewerbliche Schutzrechte umfasst, schützt das Urheberrecht geistiges Eigentum und ermöglicht es Kreativen, wirtschaftlich von ihren Werken zu profitieren.",
    "Unsere Kanzlei unterstützt Unternehmen, Selbstständige, Kreative und Start-ups umfassend dabei, ihre Ideen zu sichern, zu verteidigen und strategisch einzusetzen.",
    "<strong>Markenrecht</strong>",
    "Eine starke Marke ist weit mehr als ein Name: Sie schafft Vertrauen, grenzt Produkte voneinander ab und signalisiert Qualität. Wir begleiten Sie in allen Phasen des Markenaufbaus – von der ersten Idee bis zur erfolgreichen Verteidigung.",
    "Leistungen im Markenrecht:",
    [
      "Entwicklung und Optimierung Ihrer Markenstrategie",
      "nationale, europäische und internationale Markenanmeldungen",
      "Markenrecherche zur Vermeidung von Konflikten",
      "Markenüberwachung zur frühzeitigen Erkennung von Verletzungen",
      "Durchsetzung und Verteidigung Ihrer Markenrechte",
      "Erstellung und Prüfung von Markenlizenzverträgen",
      "Verlängerung und Verwaltung bestehender Markenportfolios",
      "Beratung zu Domain- und Namensschutz",
    ],
    "<strong>Lauterkeitsrecht</strong>",
    "Das Lauterkeitsrecht schützt Unternehmen vor unlauteren geschäftlichen Handlungen und regelt faire Marktbedingungen.",
    "Unsere Unterstützung im Lauterkeitsrecht:",
    [
      "Abmahnungen wegen Wettbewerbsverstößen",
      "Prüfung und Gestaltung von Werbemaßnahmen",
      "Durchsetzung und Abwehr von Unterlassungsansprüchen",
      "Verfahren wegen irreführender oder vergleichender Werbung",
      "Beratung zu Influencer-Marketing und Online-Werbung",
      "Compliance-Beratung für Marketingabteilungen",
    ],
    "<strong>Urheberrecht</strong>",
    "Das Urheberrecht schützt die persönliche geistige Schöpfung und ermöglicht Urheber:innen, ihre Werke wirtschaftlich zu verwerten.",
    "Leistungen im Urheberrecht:",
    [
      "Durchsetzung und Abwehr urheberrechtlicher Ansprüche",
      "Beratung zu Nutzungsrechten, Lizenzen und Verwertungsmodellen",
      "Erstellung und Prüfung von Verlags-, Lizenz-, Künstler- und Vertriebsverträgen",
      "Schutz von Software, Fotografien, Texten, Musik, Designs und anderen Werken",
      "Beratung bei Plagiaten, Content-Diebstahl und Online-Verletzungen",
      "Unterstützung bei der Rechteklärung für Medienproduktionen",
    ],
    "<strong>Erweiterte Beratungsfelder</strong>",
    "Design- und Geschmacksmusterrecht",
    [
      "Anmeldung und Verteidigung von Designs",
      "Beratung zu Produktgestaltung und Schutzstrategien",
      "Vorgehen gegen Designpiraterie",
    ],
    "Know-how- und Geheimnisschutz",
    [
      "Beratung nach dem Geschäftsgeheimnisgesetz",
      "Erstellung von Geheimhaltungsvereinbarungen",
      "Schutzkonzepte für Unternehmen",
    ],
    "E-Commerce und digitaler Rechtsschutz",
    [
      "Schutz digitaler Inhalte",
      "Beratung zu Plattformnutzung, Online-Shops und AGB",
      "Durchsetzung von Ansprüchen bei Online-Rechtsverletzungen",
    ],
    "<strong>Start-up-Beratung im IP-Recht</strong>",
    "Gerade junge Unternehmen profitieren von einer frühzeitigen und strategischen Absicherung ihrer Ideen. Wir beraten Start-ups umfassend zu Marken-, Urheber-, Medien- und Lizenzrecht – damit Wachstum und Innovation auf einem sicheren Fundament stehen.",
    "<strong>Durchsetzung und Verteidigung Ihrer Rechte</strong>",
    "Wir vertreten Sie in allen Verfahren des gewerblichen Rechtsschutzes und Urheberrechts – von der Abmahnung über einstweilige Verfügungen bis hin zu Klageverfahren. Unser Ziel ist es, Ihre Rechte effizient, strategisch und mit Nachdruck durchzusetzen.",
  ],
  bullets: [
    "Abgrenzungsvereinbarungen",
    "Abmahnungen",
    "Unionsmarken",
    "Domain und Marke",
    "Gebrauchsmusterrecht",
    "Designrecht",
    "Marken und Kennzeichen",
    "Markenanmeldungen",
    "Markenlizenzverträge",
    "Markenpiraterie",
    "Markenrecherche",
    "Markenrecht",
    "Markenstrategie",
    "Markenüberwachung",
    "Namensschutz",
    "Domainrecht",
    "Presserecht",
    "Titelschutz",
    "Urheberrecht",
    "Verlagsrecht",
    "Verlängerung von Marken",
    "Verwechslungsgefahr",
    "Werbung",
    "Wettbewerbsrecht",
    "Widerspruchsverfahren",
  ],
  more: [],
};

export default data;
